export default {
  AFTERCARE: "aftercare",
  CUSTOMER: "customer",
  CUSTOMER_ENRICHMENT: "customer_enrichment",
  POLICY: "policy",
  POLICY_ENRICHMENT: "policy_enrichment",
  POLICY_AGENCIES: "policy_agencies",
  MORTGAGE: "mortgage",
  MORTGAGE_ENRICHMENT: "mortgage_enrichment",
  MORTGAGE_AGENCIES: "mortgage_agencies",
  DAMAGE: "damage",
  DAMAGE_ENRICHMENT: "damage_enrichment",
  PORTAL_INVITATIONS: "portal_invitations",
  THEME_INTEREST_ONLY: "theme_interest_only",
};
